import { Inject, Injectable } from '@angular/core';
import { isNil } from 'lodash-es';
import { environment } from '../environments/environment';

import { UtilsService } from './utils.service';
import { SettingsValuesService } from './settings.values.service';

@Injectable({ providedIn: 'root' })
export class BarTender_ds_reflect_strings_ddService {

  constructor(
    private $utils: UtilsService,
    private $settings: SettingsValuesService,
    ) { 
  }


  public async getList(inParams: { values: string, full_text_search?: string, $top?: number, $skip?: number }): Promise<{ result?: { value?: string }[], totalCount?: number }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.values)) {
      missingRequiredInParams.push('\'values\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarTender/datasources/ds_reflect_strings_dd/getList`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }
  public async getByKeys(inParams: { values?: string, full_text_search?: string, $keys: string[] }): Promise<{ result?: { value?: string }[] }> {
    const missingRequiredInParams = [];
    if (isNil(inParams.$keys)) {
      missingRequiredInParams.push('\'$keys\'');
    }
    if (missingRequiredInParams.length) {
    }
    let url = `${environment.backendUrl}api/BarTender/datasources/ds_reflect_strings_dd/getByKeys`;
    
    const options = {
    }
    
    const body = inParams;
    
    return this.$utils.http.post(url, body, options);
    
  }

    
    hasMissingRequiredInParams(inParams: { 
      values: string, full_text_search?: string    }) {
        if(isNil(inParams.values)) {
          return true; 
        }
      return false;
    }
}
